import calculArrondi from '@/services/calcul/calculArrondi';
import { calculLigneCommandeRemise } from '@/services/devisCommandes/calcul/calculLigneCommandeRemise';
import { POURCENTAGE } from '@/configuration/devisConf';

export default function calculLigneCommandeNormal(ligneCommande) {
  if (ligneCommande === null) {
    return;
  }
  ligneCommande.totalAvantRemise = 0;
  ligneCommande.totalHt = 0;
  if (!ligneCommande.prixUnitaire < 0
    || ligneCommande.prixUnitaire === undefined
    || !ligneCommande.quantite < 0
    || ligneCommande.quantite === undefined) {
    return;
  }

  if (ligneCommande.uniteVente === POURCENTAGE) {
    ligneCommande.totalAvantRemise = (ligneCommande.prixUnitaire * ligneCommande.quantite) / 100;
  } else {
    ligneCommande.totalAvantRemise = calculArrondi(
      ligneCommande.prixUnitaire * ligneCommande.quantite,
    );
  }

  calculLigneCommandeRemise(ligneCommande);
}
